<template>
  <IntlTelInput
    v-if="ready"
    :key="locale"
    ref="phoneInput"
    class="p-inputtext p-component w-full text-sm"
    :class="{ 'p-invalid': invalid }"
    :options="intlOptions"
    @change-number="onNumberChange"
  />
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import IntlTelInput from 'intl-tel-input/vueWithUtils'
import 'intl-tel-input/build/css/intlTelInput.css'
import { loadCountries } from '@/data/countries/index.js'

const props = defineProps({
  modelValue: { type: String, default: null },
  invalid: { type: Boolean, default: false },
  placeholder: { type: String, default: null },
})

const emit = defineEmits(['update:modelValue'])
const { t, locale } = useI18n({ useScope: 'global' })
const phoneInput = ref()
const countryTranslations = ref({})
const ready = ref(false)

watch(
  locale,
  async (val) => {
    ready.value = false
    const list = await loadCountries(val)
    countryTranslations.value = Object.fromEntries(list.map((c) => [c.code.toLowerCase(), c.name]))
    ready.value = true
  },
  { immediate: true }
)

const intlOptions = computed(() => ({
  separateDialCode: true,
  strictMode: true,
  containerClass: 'w-full phone-input-sm',
  fixedDropdown: true,
  dropdownContainer: typeof document !== 'undefined' ? document.body : undefined,
  placeholderNumberType: 'MOBILE',
  customPlaceholder: () => props.placeholder ?? t('enquiryForm.phoneInput.placeholder'),
  i18n: {
    searchPlaceholder: t('enquiryForm.phoneInput.searchPlaceholder'),
    ...countryTranslations.value,
  },
}))

watch(
  () => props.modelValue,
  (newValue) => {
    if (phoneInput.value?.instance) {
      phoneInput.value.instance.setNumber(newValue ?? '')
    }
  }
)

const onNumberChange = (newNumber) => emit('update:modelValue', newNumber)
</script>
